import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import Box from 'components/box'
import SecondaryButton from 'components/secondary-button'

import styles from './access-control.css'

const AccessControl = ({ accessToken, qrUrl }) => {
  if (!accessToken && !qrUrl) {
    return null
  }

  const base = 'https://pw47p.app.goo.gl/'
  const apn = 'com.yplanapp.access'
  const link = `https://portal.yplanapp.com/access_control/auth/${accessToken}`
  const url = `${base}?link=${link}&apn=${apn}`

  return (
    <div styleName="access-control">
      <Box>
        <div styleName="container">
          <div styleName="content">
            <h2 styleName="title">Access Control</h2>
            <p styleName="text">Scan the QR code with YPlan Ticketing app to get your list of attendees.</p>
            {accessToken &&
              <a styleName="action" href={url}>
                <SecondaryButton fluid label="Get the App" />
              </a>
            }
          </div>

          {qrUrl &&
            <img styleName="image" src={qrUrl} alt="Access Control" />
          }
        </div>
      </Box>
    </div>
  )
}

AccessControl.propTypes = {
  accessToken: PropTypes.string,
  qrUrl: PropTypes.string,
}

export default CSSModules(AccessControl, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/access-control/access-control.js
 **/